document.addEventListener('DOMContentLoaded', function () {

  function updateEngravingFields() {

    const frontInput = document.querySelector(
      '[data-custom-option-input="d4d75f80-4e06-463e-b55b-1ae53a589fc0"]'
    );

    const backInput = document.querySelector(
      '[data-custom-option-input="custom_option_aUTHdH"], [data-custom-option-input="54b05b66-8e7b-49c3-a8ba-877cf5f2b683"]'
    );

    const variantSelect = document.querySelector(
      'select[name^="options"]'
    );

    if (!frontInput || !backInput || !variantSelect) return;

    const frontContainer = frontInput.closest(
      '.product__controls-group'
    );

    const backContainer = backInput.closest(
      '.product__controls-group'
    );

    if (!frontContainer || !backContainer) return;

    const selectedValue = variantSelect.value;

    if (selectedValue === 'Frontal') {

      frontContainer.style.display = '';
      backContainer.style.display = 'none';

      backInput.value = '';

    } else if (selectedValue === 'Trasero') {

      frontContainer.style.display = 'none';
      backContainer.style.display = '';

      frontInput.value = '';

    } else if (selectedValue === 'Ambas caras') {

      frontContainer.style.display = '';
      backContainer.style.display = '';

    }

  }


  updateEngravingFields();


  document.addEventListener('change', function (event) {

    if (event.target.matches('select[name^="options"]')) {
      setTimeout(updateEngravingFields, 100);
    }

  });

});